import React, { useEffect, useState } from 'react'
import { FormGroup, Label, Input } from 'reactstrap'
import './RadioGroup.css'

const RadioGroup = ({ value, options, defaultValue, textHeader, containerClassName, onChange }) => {
    const [selectedOption, setSelectedOption] = useState(defaultValue || '')

    useEffect(() => {
        if (value !== undefined) {
            setSelectedOption(value)
        }
    }, [value])

    const handleChange = event => {
        const newValue = event.target.value
        const item = options.find(option => option.value === newValue)

        setSelectedOption(item.value)
        onChange(item)
    }

    return (
        <div className={`${containerClassName}`}>
            <h4>{textHeader}</h4>
            {options.map((option, index) => (
                <FormGroup key={index}>
                    <Label className="radio-label">
                        <Input
                            type="radio"
                            name="radioOptions"
                            value={option.value}
                            checked={selectedOption === option.value}
                            onChange={handleChange}
                        />
                        {option.label}
                    </Label>
                </FormGroup>
            ))}
        </div>
    )
}

export default RadioGroup
